const DELAY = 250;
/**
 * Redirect to page. Add a delay to get around transitions completing. Eg, a confirm modal must complete closing
 * before we change pages, otherwise it will stay on the screen.
 * @TODO - Figure out how to detect when a transition finishes!
 * @param router
 * @param opts
 */
export function goToPage(router, opts) {
  opts.params = opts.params || {};
  opts.delay = !!opts.delay;
  setTimeout(
    () => {
      router.push({ name: opts.name, params: opts.params });
    },
    opts.delay ? DELAY : 0,
  );
}
